// Custom user-saved printer profiles. Stored in localStorage as an array under
// 'clayforge.customProfiles'. Built-in profiles are read-only; users clone one,
// tweak it, and save under a new name.

import type { PrinterProfile } from '../core/types';

const KEY = 'clayforge.customProfiles';

export function loadCustomProfiles(): PrinterProfile[] {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    const arr = JSON.parse(raw);
    return Array.isArray(arr) ? arr : [];
  } catch { return []; }
}

export function saveCustomProfiles(profiles: PrinterProfile[]): void {
  try { localStorage.setItem(KEY, JSON.stringify(profiles)); } catch { /* full / disabled */ }
}

export function addOrUpdateCustom(profile: PrinterProfile): PrinterProfile[] {
  const list = loadCustomProfiles();
  const idx = list.findIndex((p) => p.id === profile.id);
  if (idx >= 0) list[idx] = profile; else list.push(profile);
  saveCustomProfiles(list);
  return list;
}

export function removeCustom(id: string): PrinterProfile[] {
  const list = loadCustomProfiles().filter((p) => p.id !== id);
  saveCustomProfiles(list);
  return list;
}

/** Generate a new unique id for a cloned profile. */
export function makeCustomId(name: string): string {
  const slug = name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || 'profile';
  return `custom-${slug}-${Date.now().toString(36)}`;
}
